import MoSad from '@assets/animations/mo/moSad.json';
import {Box, Typography} from '@mui/material';
import {motion} from 'framer-motion';
import Lottie from 'lottie-react';
import {useTranslation} from 'react-i18next';

import {MessageBubble} from '@/app/shared-components';
import {
  EMessageBubbleSizeVariant,
  EMessageBubbleTailVariant,
  EMessageBubbleToneVariant,
} from '@/app/shared-components/MessageBubble/enums';

import {KYC_DECLINED_ANIMATION} from './constants';
import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';
import './styles';

const KycDeclinedContent = () => {
  const {t} = useTranslation();
  const {showDescription, showTitle} = useViewModelProvider();

  return (
    <Box className="kyc-declined-page-container">
      <Box className="kyc-declined-page-content">
        <motion.div
          className="kyc-declined-copy-wrapper"
          initial={false}
          animate={{opacity: showTitle ? 1 : 0}}
          transition={{duration: 0.15}}>
          <motion.div
            initial={{
              opacity: 0,
              x: KYC_DECLINED_ANIMATION.TITLE_INITIAL_X,
            }}
            animate={{
              opacity: showTitle ? 1 : 0,
              x: showTitle ? 0 : KYC_DECLINED_ANIMATION.TITLE_INITIAL_X,
            }}
            transition={{
              duration: KYC_DECLINED_ANIMATION.TITLE_DURATION,
              ease: 'easeOut',
            }}>
            <Typography className="kyc-declined-title">
              {t('kyc.declined.title')}
            </Typography>
          </motion.div>

          <motion.div
            initial={{
              opacity: 0,
              x: KYC_DECLINED_ANIMATION.DESCRIPTION_INITIAL_X,
            }}
            animate={{
              opacity: showDescription ? 1 : 0,
              x: showDescription
                ? 0
                : KYC_DECLINED_ANIMATION.DESCRIPTION_INITIAL_X,
            }}
            transition={{
              duration: KYC_DECLINED_ANIMATION.DESCRIPTION_DURATION,
              ease: 'easeOut',
            }}>
            <Typography className="kyc-declined-description">
              {t('kyc.declined.description')}
            </Typography>
          </motion.div>
        </motion.div>

        <Box className="kyc-declined-illustration-wrap">
          <motion.div
            className="kyc-declined-lottie-motion"
            initial={{
              opacity: 0,
              y: KYC_DECLINED_ANIMATION.LOTTIE_INITIAL_Y,
            }}
            animate={{opacity: 1, y: 0}}
            transition={{
              delay: KYC_DECLINED_ANIMATION.LOTTIE_DELAY,
              duration: KYC_DECLINED_ANIMATION.LOTTIE_DURATION,
              ease: 'easeOut',
            }}>
            <MessageBubble
              text={t('kyc.declined.bubble')}
              className="kyc-declined-bubble"
              tailVariant={EMessageBubbleTailVariant.Triangle}
              sizeVariant={EMessageBubbleSizeVariant.Md}
              toneVariant={EMessageBubbleToneVariant.Elevated}
            />

            <Lottie
              animationData={MoSad}
              loop
              autoplay
              className="kyc-declined-lottie"
            />
          </motion.div>
        </Box>
      </Box>
    </Box>
  );
};

const KycDeclinedPage = () => (
  <ViewModelProvider>
    <KycDeclinedContent />
  </ViewModelProvider>
);

export default KycDeclinedPage;
